import React, { Component } from 'react'
import { Container, Table, Button, Spinner } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers';
import Calendar from 'react-calendar';
  
class JobCalendar extends Component {
    constructor(props) {
      super(props);
      this.state = {
        listInComplete: false,
        inCompleteLoading: false,
        completedLoading: false,
        CompanyList : [],
  
      }
      this.onChange = this.onChange.bind(this)
    }
    onChange = (date) => {
        date = new Date(date)
        let days = date.getDate()
        if (parseInt(days) < 10){
            days = `0${days}`
        }
        let month = parseInt(date.getMonth()) + 1
        if(parseInt(month) < 10){
            month = `0${month}`
        }
        let year = date.getFullYear()
        date = `${year}-${month}-${days}`
        this.props.history.push({
          pathname: '/Job',
          state: date,
        })
      }
    
    render() {
      return (
        <Container>
          <AdminNav></AdminNav>
          <br></br>
          <Calendar
            onChange={this.onChange}
          />
  
        </Container>
      )
    }
  }
  
  
  export default withRouter(JobCalendar);
  